import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import Benefits from "../components/landing/Benefits";
import PainPoints from "../components/landing/PainPoints";
import ProcessMethod from "../components/landing/ProcessMethod";
import RecordingOptions from "../components/landing/RecordingOptions";
import CoverageMap from "../components/landing/CoverageMap";
import LeadForm from "../components/landing/LeadForm";
import Sectors from "../components/landing/Sectors";
import Comparison from "../components/landing/Comparison";
import ROISection from "../components/landing/ROISection";
import StudioGallery from "../components/landing/StudioGallery";
import GoogleReviews from "../components/landing/GoogleReviews";
import FAQ from "../components/landing/FAQ";
import FinalCTA from "../components/landing/FinalCTA";
import Footer from "../components/landing/Footer";
import MobileCTA from "../components/landing/MobileCTA";
// Guide-related components hidden temporarily
// import ExitPopup from "../components/landing/ExitPopup";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-galvani-bg">
      <Header />
      <main>
        <HeroSection />
        <Benefits />
        <PainPoints />
        <ProcessMethod />
        <RecordingOptions />
        <CoverageMap />
        <LeadForm />
        <Sectors />
        <Comparison />
        <ROISection />
        <StudioGallery />
        <GoogleReviews />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <MobileCTA />
      {/* <ExitPopup /> */}
    </div>
  );
}
